import PropTypes from 'prop-types';
import MLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Person from '@material-ui/icons/Person';
import clsx from 'clsx';
import UrlLink from './url-link';
import MaterialLink from './material-link';
import { instagramUrl } from '../utils/urls';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: theme.spacing(2),
    '&:not(:first-child)': {
      marginTop: theme.spacing(2)
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5, 0),
  },
  metaIcon: {
    marginRight: theme.spacing(0.5),
    opacity: 0.6,
    fontSize: 20,
  },
  metaIconSvg: {
    width: 16,
    height: 16,
    marginRight: theme.spacing(1),
    opacity: 0.6,
  },
  inline: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(2),
    }
  },
  compact: {
    marginBottom: theme.spacing(1),
    '&:not(:first-child)': {
      marginTop: theme.spacing(1),
    },
  },
}));

const SocialLinks = ({ source, inline, compact }) => {
  const classes = useStyles();

  if (!source.websiteUrl && !source.instagramUsername && !source.city && !source.pronouns) {
    return null;
  }

  return (
    <div className={clsx(classes.wrapper, { [classes.inline]: inline, [classes.compact]: compact })}>
      {source.pronouns && (
        <div className={classes.item}>
          <Person className={classes.metaIcon} />
          {source.pronouns}
        </div>
      )}
      {source.websiteUrl && (
        <div className={classes.item}>
          <img src="/static/link-solid.svg" className={classes.metaIconSvg} />
          <UrlLink url={source.websiteUrl} />
        </div>
      )}
      {source.instagramUsername && (
        <div className={classes.item}>
          <img src="/static/instagram-brands.svg" className={classes.metaIconSvg} />
          <MLink
            href={instagramUrl(source.instagramUsername)}
            rel="noopener noreferrer"
          >
            @{source.instagramUsername.replace(/^@/, '')}
          </MLink>
        </div>
      )}
      {source.city && (
        <div className={classes.item}>
          <img src="/static/globe-americas-solid.svg" className={classes.metaIconSvg} />
          <MaterialLink
            href="/cities/[slug]"
            as={`/cities/${source.city.slug}`}
            title={`${source.city.name}, ${source.city.locality}`}
          >
            {source.city.name}
          </MaterialLink>
        </div>
      )}
    </div>
  );
};

SocialLinks.propTypes = {
  source: PropTypes.object,
  inline: PropTypes.bool,
  compact: PropTypes.bool,
};

SocialLinks.defaultProps = {
  inline: false,
  compact: false,
};

export default SocialLinks;
